// import wovon aus welcher Library oder Ordner
import React from "react"
import ReactDOM from "react-dom"
import { AuthProvider } from "./components/authcontext";
import { BrowserRouter } from "react-router-dom";
import ShopProvider from "./components/shopinfo";
import { CartProvider } from "./components/context4cart";
//import ( StrictMode )
import * as ReactDomClient from "react-dom/client";

import "bootstrap/dist/css/bootstrap.min.css"
import "./index.css";
import App from "./PresseWebShop";





const fetchShopData = async (pgid) => {
  if (!pgid) {
    console.warn(" No PGID found — skipping shop data fetch.");
    document.body.innerHTML = `
      <div style="
        display:flex;
        align-items:center;
        justify-content:center;
        height:100vh;
        font-family:sans-serif;
        font-size:1.2rem;
        color:#555;
      ">
        Couldn’t load shop data (missing PGID).
      </div>
    `;
    return null;
  }

  try {
    //console.log("🔄 Fetching shop data early for PGID:", pgid);
    const response = await fetch(`/api-shopinfo/${pgid}`);
    const data = await response.json();
    //console.log("Shop data fetched early:", data);
    return data.success ? data.data : null;
  } catch (error) {
    //console.error(" Error fetching shop data early:", error);
    document.body.innerHTML = `
      <div style="
        display:flex;
        align-items:center;
        justify-content:center;
        height:100vh;
        font-family:sans-serif;
        color:#555;
      ">
        Something went wrong loading shop data.
      </div>
    `;
    return null;
  }
};

const getPgidFromSubdomain = () => {
  const subdomain = window.location.hostname.split(".")[0];
  return subdomain.match(/^\d+$/) ? subdomain : null;
};



const loadShopFavicon = (pgid) => {
  const iconUrl = `https://www.pressewebshop2.de/images/${pgid}/favicon.ico/`;

   // alt
   const existingIcon = document.getElementById("shop-favicon");
   if (existingIcon) {
     existingIcon.remove();
   }
 
   // neu
   const link = document.createElement("link");
   link.id = "shop-favicon";
   link.rel = "icon";
   link.type = "image/x-icon";
   link.href = iconUrl;
 
   link.onload = () => {
     console.log(`Loaded favicon for PGID ${pgid}`);
   };
 
   link.onerror = () => {
     console.warn(`No favicon found for PGID ${pgid} - using default favicon.`);
     link.remove();
   };
 
   document.head.appendChild(link);
 };


//custom color scheme

const loadShopColorCss = (pgid) => {
  if (!pgid) return;

  const cssUrl = `https://www.pressewebshop2.de/images/${pgid}/color.css/`;

  const existingLink = document.getElementById("shop-color-css");
  if (existingLink) {
    existingLink.remove();
  }

  const link = document.createElement("link");
  link.id = "shop-color-css";
  link.rel = "stylesheet";
  link.href = cssUrl;

  link.onload = () => {
    console.log(`Loaded shop color.css for PGID ${pgid}`);
  };

  link.onerror = () => {
    console.warn(`No color.css found for PGID ${pgid} - using default colors.`);
    link.remove();
  };

  document.head.appendChild(link);
};



const pgid = getPgidFromSubdomain();
//console.log("PGID extracted early:", pgid);

loadShopColorCss(pgid);
loadShopFavicon(pgid);

const root = ReactDOM.createRoot(document.getElementById("root"));

// Handle missing pgid BEFORE rendering React
if (!pgid) {
  console.warn(" No PGID detected in subdomain.");
  document.body.innerHTML = `
    <div style="
      display:flex;
      flex-direction:column;
      align-items:center;
      justify-content:center;
      height:100vh;
      font-family:sans-serif;
      text-align:center;
      color:#555;
    ">
      <div style="font-size:2rem;"> Oops!</div>
      <div style="margin-top:1rem;">No PGID found in subdomain.</div>
      <div style="margin-top:0.5rem;font-size:0.9rem;">
        Please make sure you're accessing this via a valid shop subdomain.
      </div>
    </div>
  `;
} else {
  

  // FEHLER WENN DIE PG ID NICHT GELADEN WIRD


  fetchShopData(pgid)
    .then((initialShopData) => {
      if (!initialShopData) {
        console.warn("shopData is null, rendering fallback page.");
        document.body.innerHTML = `
          <div style="
            display:flex;
            align-items:center;
            justify-content:center;
            height:100vh;
            font-family:sans-serif;
            color:#555;
          ">
             Die Seite konnte nicht geladen werden.
          </div>
        `;
        return; 
      }

      console.log("Shop data ready, rendering app...");
      root.render(
        <React.StrictMode>
          <BrowserRouter>
            <AuthProvider>
              <ShopProvider initialShopData={initialShopData} pgid={pgid}>
                <CartProvider>
                  <App />
                </CartProvider>
              </ShopProvider>
            </AuthProvider>
          </BrowserRouter>
        </React.StrictMode>
      );
    })
    .catch((err) => {
      console.error("Error during shop data fetch:", err);
      document.body.innerHTML = `
        <div style="
          display:flex;
          align-items:center;
          justify-content:center;
          height:100vh;
          font-family:sans-serif;
          color:#555;
        ">
          Something went wrong while initializing the app.
        </div>
      `;
    });
}